export default __webpack_public_path__ + "static/media/Version (5) - Deathly Hallows_02.fc6d7837.jpg";